export default __webpack_public_path__ + "498a4a4521c4cd3ff86942d5f466907b.svg";